import { CSSObject } from '@chakra-ui/react';
import { EOnboardingPageType } from '../OnboardingWrapper.types';

const isSignup = ({ pageType }: any) => pageType === EOnboardingPageType.SignUp;

export const GridWrapper: CSSObject = {
  position: 'relative',
  boxShadow: [null, null, '0px 8px 30px rgba(0, 0, 0, 0.2)'],
  gridTemplateColumns: ['1fr', '300px 460px'],
  gridTemplateRows: ['336px 1fr', '1fr'],
  gridAutoFlow: [null, 'row'],
  gridTemplateAreas: [
    `
        'aside'
        'content'
      `,
    `
        'aside content'
      `,
  ],
  minH: ['full', null, '668px'],
  w: ['100dvw', null, 'unset'],
};

export const BoxAside: CSSObject = {
  minH: 'full',
  h: 'full',
  borderLeftRadius: [null, null, 'lg'],
};

export const CloseButton: CSSObject = {
  position: 'absolute',
  right: ['4', null, '10'],
  top: ['4', null, '10'],
  border: '2px',
  p: '0.5',
  boxSize: ['6', null, '7'],
  bg: ['transparent', null, 'white'],
  alignSelf: ['flex-start', null, 'unset'],
  borderColor: ['white', null, 'gamma.500'],
  color: ['white', null, 'gamma.500'],
};

export const BoxContent = (pageType: string): CSSObject => ({
  bg: 'white',
  px: ['2', null, '10'],
  pt: ['4', null, isSignup(pageType) ? '20' : '40'],
  pb: ['8', null, '10'],
  h: 'full',
  color: 'gray.500',
  fontWeight: 'semibold',
  fontSize: 'xs',
  display: 'flex',
  flexDir: 'column',
  justifyContent: 'flex-start',

  borderRightRadius: ['unset', null, 'lg'],

  '#title-dropdown-select': {
    borderRadius: 'base',
    bg: 'white',
    fontFamily: 'roboto',
    fontSize: 'xs',
    color: 'gray.500',
    fontWeight: 'bold',
    borderColor: 'gray.300',
  },

  '.chakra-form__label': {
    color: 'gray.500',
    fontWeight: 'semibold',
    fontSize: 'xs',
    mb: '1.5',
  },

  '.chakra-checkbox__control': {
    bg: 'white',
    color: 'gray.500',
  },
  '.chakra-checkbox__control[data-checked]': {
    bg: 'white',
    borderColor: 'gray.300',
    color: 'gray.700',
  },

  '.react-date-picker__inputGroup': {
    color: 'gray.700',
    fontWeight: 'semibold',
    fontSize: 'sm',
  },

  '.chakra-input__left-addon': {
    color: 'black',
  },

  '.chakra-input, .chakra-select, .react-date-picker__wrapper': {
    bg: 'gray.50',
    border: '1px',
    borderColor: 'gray.300',
    h: '9',
    _placeholder: {
      fontSize: 'xs',
    },
  },
  a: {
    mt: '2',
    color: 'gamma.500',
    ml: '0',
  },
});
